const MarketClosed = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18" fill="none"><circle fill="#ff5252" cx="9" cy="9" r="4"></circle></svg>

    )
}
export default MarketClosed